export const SETS = {
  A1: [
    {
      id: 'maison',
      title: 'À la maison',
      questions: [
        { clue: "C'est dans la cuisine. On cuisine avec.", emoji: '🍳', answer: 'La poêle' },
        { clue: "C'est doux. On dort dessus.", emoji: '🛏️', answer: 'Le lit' },
        { clue: "C'est dans le salon. On regarde la télé dessus.", emoji: '🛋️', answer: 'Le canapé' },
        { clue: "C'est dans la salle de bain. On se lave avec.", emoji: '🚿', answer: 'La douche' },
        { clue: "J'ai quatre pieds, mais je ne marche pas.", emoji: '🍽️', answer: 'La table' },
        { clue: "On met les vêtements dedans.", emoji: '👗', answer: "L'armoire" },
        { clue: "C'est chaud. On le met en hiver.", emoji: '🔥', answer: 'Le chauffage' },
        { clue: "J'ai une porte. Je garde les aliments au froid.", emoji: '❄️', answer: 'Le réfrigérateur' },
        { clue: "C'est sur la table. On mange avec.", emoji: '🍴', answer: 'La fourchette' },
        { clue: 'On regarde dedans pour se voir.', emoji: '🪞', answer: 'Le miroir' },
      ],
      speaking: [
        "C'est grand ou petit ?",
        "C'est dans la cuisine ?",
      ],
    },
    {
      id: 'animaux',
      title: 'Les animaux',
      questions: [
        { clue: 'Je dis "meuh".', emoji: '🐄', answer: 'La vache' },
        { clue: "J'ai des ailes. Je vole.", emoji: '🐦', answer: "L'oiseau" },
        { clue: 'Je suis long et je rampe.', emoji: '🐍', answer: 'Le serpent' },
        { clue: "Je vis dans la mer. J'ai des nageoires.", emoji: '🐠', answer: 'Le poisson' },
        { clue: "J'ai de longues oreilles. J'aime les carottes.", emoji: '🐰', answer: 'Le lapin' },
        { clue: "Je suis grand et gris. J'ai une trompe.", emoji: '🐘', answer: "L'éléphant" },
        { clue: 'Je suis noir et blanc. Je vis au pôle Sud.', emoji: '🐧', answer: 'Le pingouin' },
        { clue: 'Je dis "cocorico".', emoji: '🐓', answer: 'Le coq' },
        { clue: 'Je suis petit et je dis "bzz".', emoji: '🐝', answer: "L'abeille" },
        { clue: "Je suis fort, j'ai une crinière.", emoji: '🦁', answer: 'Le lion' },
      ],
      speaking: [
        'Quel animal tu préfères ? Pourquoi ?',
        'Il est grand ou petit ?',
      ],
    },
    {
      id: 'aliments',
      title: 'Les aliments',
      questions: [
        { clue: "C'est rouge. C'est un fruit.", emoji: '🍎', answer: 'La pomme' },
        { clue: "C'est jaune et long.", emoji: '🍌', answer: 'La banane' },
        { clue: "C'est froid et sucré.", emoji: '🍦', answer: 'La glace' },
        { clue: 'On le boit le matin.', emoji: '☕', answer: 'Le café' },
        { clue: "C'est chaud. On le mange à midi.", emoji: '🍲', answer: 'La soupe' },
        { clue: "C'est salé. On le mange avec des frites.", emoji: '🍔', answer: 'Le hamburger' },
        { clue: "C'est rond et on la coupe en parts.", emoji: '🍕', answer: 'La pizza' },
        { clue: "C'est une boisson. Ce n'est pas sucré.", emoji: '💧', answer: "L'eau" },
        { clue: "C'est un dessert avec du chocolat.", emoji: '🍫', answer: 'Le gâteau' },
        { clue: 'On le mange avec du beurre ou de la confiture.', emoji: '🍞', answer: 'Le pain' },
      ],
      speaking: [
        'Tu aimes la soupe ?',
        'Tu préfères quoi ?',
      ],
    },
    {
      id: 'ecole',
      title: "L'école",
      questions: [
        { clue: 'On écrit avec.', emoji: '✏️', answer: 'Le crayon' },
        { clue: 'On lit les histoires dedans.', emoji: '📖', answer: 'Le livre' },
        { clue: 'On écrit dessus avec une craie.', emoji: '🧑‍🏫', answer: 'Le tableau' },
        { clue: 'On met les livres dedans.', emoji: '🎒', answer: 'Le sac à dos' },
        { clue: "On s'assoit dessus.", emoji: '💺', answer: 'La chaise' },
        { clue: 'On apprend les nombres ici.', emoji: '➗', answer: 'La classe de maths' },
        { clue: 'La personne qui enseigne.', emoji: '👩‍🏫', answer: 'Le professeur' },
        { clue: "C'est un objet pour couper le papier.", emoji: '✂️', answer: 'Les ciseaux' },
        { clue: 'On colorie avec.', emoji: '🖍️', answer: 'Les crayons de couleur' },
        { clue: 'On écrit sur elle.', emoji: '📄', answer: 'La feuille' },
      ],
      speaking: [
        'Tu as un sac bleu ?',
        'Oui, et toi ?',
        "Moi, j'ai un sac rouge !",
      ],
    },
    {
      id: 'vetements',
      title: 'Les vêtements',
      questions: [
        { clue: 'On le porte sur la tête.', emoji: '🧢', answer: 'Le chapeau' },
        { clue: 'On le porte aux pieds.', emoji: '👟', answer: 'Les chaussures' },
        { clue: "On le porte quand il fait froid.", emoji: '🧥', answer: 'Le manteau' },
        { clue: 'On le met sur les jambes.', emoji: '👖', answer: 'Le pantalon' },
        { clue: 'On le porte en été.', emoji: '👗', answer: 'La robe' },
        { clue: 'On le met sur le haut du corps.', emoji: '👕', answer: 'Le tee-shirt' },
        { clue: 'On le met la nuit.', emoji: '💤', answer: 'Le pyjama' },
        { clue: "On le met quand il pleut.", emoji: '☔', answer: "L'imperméable" },
        { clue: "On le met au cou quand il fait froid.", emoji: '🧣', answer: "L'écharpe" },
        { clue: 'On le met sur les mains.', emoji: '🧤', answer: 'Les gants' },
      ],
      speaking: [
        "Qu'est-ce que tu portes aujourd'hui ?",
        'Je porte un tee-shirt bleu et un pantalon noir.',
      ],
    },
    {
      id: 'ville',
      title: 'La ville',
      questions: [
        { clue: 'On achète du pain ici.', emoji: '🥖', answer: 'La boulangerie' },
        { clue: 'On voit des films ici.', emoji: '🎬', answer: 'Le cinéma' },
        { clue: 'On va voir le médecin ici.', emoji: '🏥', answer: "L'hôpital" },
        { clue: 'On prend le bus ici.', emoji: '🚌', answer: "L'arrêt de bus" },
        { clue: 'On achète des médicaments ici.', emoji: '💊', answer: 'La pharmacie' },
        { clue: 'On étudie ici.', emoji: '🎓', answer: "L'école" },
        { clue: 'On mange au restaurant ici.', emoji: '🍽️', answer: 'Le restaurant' },
        { clue: 'On marche dessus dans la rue.', emoji: '🚶', answer: 'Le trottoir' },
        { clue: 'Il y a beaucoup de voitures ici.', emoji: '🚗', answer: 'La route' },
        { clue: 'On achète des livres ici.', emoji: '📚', answer: 'La librairie' },
      ],
      speaking: [
        'Tu vas souvent au cinéma ?',
        "Oui, j'aime beaucoup les films !",
      ],
    },
    {
      id: 'actions-quotidiennes',
      title: 'Les actions quotidiennes',
      questions: [
        { clue: 'Je fais ça le matin après le réveil.', emoji: '🪥', answer: 'Se brosser les dents' },
        { clue: 'Je fais ça le soir pour dormir.', emoji: '😴', answer: 'Se coucher' },
        { clue: 'Je fais ça pour manger.', emoji: '🍴', answer: 'Manger' },
        { clue: "Je fais ça avec de l'eau et du savon.", emoji: '🧼', answer: 'Se laver' },
        { clue: "Je fais ça pour aller au travail ou à l'école.", emoji: '🚶', answer: 'Partir' },
        { clue: 'Je fais ça avec un livre.', emoji: '📖', answer: 'Lire' },
        { clue: 'Je fais ça avec un téléphone.', emoji: '📱', answer: 'Appeler' },
        { clue: 'Je fais ça pour apprendre.', emoji: '📝', answer: 'Étudier' },
        { clue: 'Je fais ça pour me reposer.', emoji: '🛋️', answer: 'Se reposer' },
        { clue: 'Je fais ça pour regarder un film.', emoji: '📺', answer: 'Regarder la télé' },
      ],
      speaking: [
        "Qu'est-ce que tu fais le matin ?",
        'Je me réveille, je me lave et je prends le petit déjeuner.',
      ],
    },
    {
      id: 'parties-du-corps',
      title: 'Les parties du corps',
      questions: [
        { clue: 'Je vois avec.', emoji: '👀', answer: 'Les yeux' },
        { clue: "J'écoute avec.", emoji: '👂', answer: 'Les oreilles' },
        { clue: 'Je mange avec.', emoji: '👄', answer: 'La bouche' },
        { clue: 'Je marche avec.', emoji: '🚶', answer: 'Les pieds' },
        { clue: 'Je prends avec.', emoji: '✋', answer: 'Les mains' },
        { clue: 'Je pense avec.', emoji: '🧠', answer: 'La tête' },
        { clue: 'Je sens avec.', emoji: '👃', answer: 'Le nez' },
        { clue: 'Je parle avec.', emoji: '🗣️', answer: 'La bouche' },
        { clue: 'Je tourne avec.', emoji: '🔄', answer: 'Le cou' },
        { clue: 'Je cours avec.', emoji: '🏃', answer: 'Les jambes' },
      ],
      speaking: [
        'Quelle partie du corps utilises-tu pour écrire ?',
        "J'utilise mes mains.",
      ],
    },
    {
      id: 'transports',
      title: 'Les transports',
      questions: [
        { clue: 'Je prends ça pour aller loin dans le ciel.', emoji: '✈️', answer: "L'avion" },
        { clue: "Je prends ça pour voyager sur l'eau.", emoji: '🚢', answer: 'Le bateau' },
        { clue: 'Je prends ça en ville.', emoji: '🚕', answer: 'Le taxi' },
        { clue: 'Je conduis ça.', emoji: '🚗', answer: 'La voiture' },
        { clue: 'Je prends ça avec beaucoup de personnes.', emoji: '🚌', answer: 'Le bus' },
        { clue: 'Je prends ça sous la terre.', emoji: '🚇', answer: 'Le métro' },
        { clue: 'Je vais à pied sans transport.', emoji: '🚶', answer: 'Marcher' },
        { clue: 'Je prends ça pour aller vite entre les villes.', emoji: '🚄', answer: 'Le train' },
        { clue: 'Je roule avec ça.', emoji: '🚲', answer: 'Le vélo' },
        { clue: "Je prends ça pour aller à l'école parfois.", emoji: '🚐', answer: 'Le minibus' },
      ],
      speaking: [
        "Comment vas-tu à l'école ?",
        "Je vais à l'école en bus.",
      ],
    },
    {
      id: 'metiers',
      title: 'Les métiers',
      questions: [
        { clue: "Il travaille à l'hôpital.", emoji: '🏥', answer: 'Le médecin' },
        { clue: "Il enseigne à l'école.", emoji: '🧑‍🏫', answer: 'Le professeur' },
        { clue: 'Il cuisine dans un restaurant.', emoji: '👨‍🍳', answer: 'Le cuisinier' },
        { clue: 'Il construit des maisons.', emoji: '🏗️', answer: 'Le maçon' },
        { clue: 'Il aide les gens avec la loi.', emoji: '⚖️', answer: "L'avocat" },
        { clue: 'Il vend des produits.', emoji: '🛍️', answer: 'Le vendeur' },
        { clue: 'Il conduit un taxi.', emoji: '🚖', answer: 'Le chauffeur' },
        { clue: 'Il travaille dans un bureau.', emoji: '💼', answer: "L'employé" },
        { clue: 'Il soigne les animaux.', emoji: '🐶', answer: 'Le vétérinaire' },
        { clue: 'Il protège les personnes.', emoji: '👮', answer: 'Le policier' },
      ],
      speaking: [
        'Quel métier veux-tu faire ?',
        'Je veux être médecin.',
      ],
    },
  ],
  A2: [
    {
      id: 'maison-a2',
      title: 'À la maison',
      questions: [
        { clue: "Tu veux regarder un film dans le salon. Tu t'assois sur quelque chose de confortable.", emoji: '🛋️', answer: 'Le canapé' },
        { clue: "Tu veux dormir. Tu vas dans ta chambre et tu t'allonges sur…", emoji: '🛏️', answer: 'Le lit' },
        { clue: 'Il fait froid chez toi. Tu allumes un appareil pour chauffer la maison.', emoji: '🔥', answer: 'Le chauffage' },
        { clue: 'Tu veux prendre une douche le matin. Tu vas dans…', emoji: '🚿', answer: 'La salle de bain' },
        { clue: 'Tu veux conserver des aliments au froid. Tu utilises…', emoji: '❄️', answer: 'Le réfrigérateur' },
        { clue: 'Tu veux cuisiner. Tu utilises cet objet pour préparer les aliments.', emoji: '🍳', answer: 'La poêle' },
        { clue: "Tu veux manger. Tu t'assois devant…", emoji: '🍽️', answer: 'La table' },
        { clue: 'Tu veux voir ton visage. Tu regardes dans…', emoji: '🪞', answer: 'Le miroir' },
        { clue: 'Tu veux ranger tes vêtements. Tu les mets dans…', emoji: '👗', answer: "L'armoire" },
        { clue: 'Tu veux regarder les informations. Tu allumes…', emoji: '📺', answer: 'La télévision' },
      ],
      speaking: [
        "Qu'est-ce que tu fais le soir à la maison ?",
        'Quelle pièce de la maison tu préfères ? Pourquoi ?',
      ],
    },
    {
      id: 'ecole-a2',
      title: "L'école",
      questions: [
        { clue: 'Tu écris pendant le cours avec…', emoji: '✏️', answer: 'Un stylo / crayon' },
        { clue: 'Le professeur écrit sur…', emoji: '🧑‍🏫', answer: 'Le tableau' },
        { clue: 'Tu mets tes livres dans…', emoji: '🎒', answer: 'Le sac à dos' },
        { clue: 'Tu lis une histoire dans…', emoji: '📖', answer: 'Le livre' },
        { clue: "Tu t'assois sur…", emoji: '💺', answer: 'La chaise' },
        { clue: 'Tu coupes du papier avec…', emoji: '✂️', answer: 'Les ciseaux' },
        { clue: 'Tu corriges une erreur avec…', emoji: '🧽', answer: 'La gomme' },
        { clue: 'Tu dessines avec…', emoji: '🖍️', answer: 'Les crayons de couleur' },
        { clue: 'Tu écris tes réponses sur…', emoji: '📄', answer: 'La feuille' },
        { clue: 'Tu apprends les mathématiques dans…', emoji: '➗', answer: 'La classe' },
      ],
      speaking: [
        'Quelle matière tu préfères ?',
        'Tu préfères travailler seul ou en groupe ?',
      ],
    },
    {
      id: 'voyages-a2',
      title: 'Les voyages',
      questions: [
        { clue: 'Tu veux aller dans un autre pays rapidement. Tu prends…', emoji: '✈️', answer: "L'avion" },
        { clue: 'Tu voyages avec une valise. Tu la mets à…', emoji: '🧳', answer: "L'aéroport" },
        { clue: 'Tu dors pendant ton voyage dans…', emoji: '🏨', answer: "L'hôtel" },
        { clue: 'Tu visites une ville et tu prends des photos avec…', emoji: '📸', answer: 'Le téléphone' },
        { clue: 'Tu veux manger. Tu vas dans…', emoji: '🍽️', answer: 'Le restaurant' },
        { clue: 'Tu cherches ton chemin. Tu utilises…', emoji: '🗺️', answer: 'Une carte / GPS' },
        { clue: 'Tu prends un moyen de transport en ville.', emoji: '🚌', answer: 'Le bus / métro' },
        { clue: 'Tu arrives dans un pays étranger. Tu montres…', emoji: '🛂', answer: 'Le passeport' },
        { clue: 'Tu achètes des souvenirs dans…', emoji: '🛍️', answer: 'Un magasin' },
        { clue: 'Tu veux te déplacer rapidement en ville. Tu prends…', emoji: '🚕', answer: 'Un taxi' },
      ],
      speaking: [
        "Tu aimes voyager seul ou avec quelqu'un ?",
        'Quel pays veux-tu visiter ?',
      ],
    },
    {
      id: 'sport-a2',
      title: 'Le sport',
      questions: [
        { clue: 'Tu cours dans un parc. Tu fais…', emoji: '🏃', answer: 'Du jogging' },
        { clue: 'Tu joues avec un ballon et tu marques des buts.', emoji: '⚽', answer: 'Le football' },
        { clue: "Tu nages dans l'eau.", emoji: '🏊', answer: 'La natation' },
        { clue: 'Tu fais du sport dans une salle.', emoji: '🏋️', answer: 'La salle de sport' },
        { clue: 'Tu fais du vélo dans la rue.', emoji: '🚲', answer: 'Le cyclisme' },
        { clue: 'Tu joues avec une raquette.', emoji: '🎾', answer: 'Le tennis' },
        { clue: 'Tu fais des exercices pour ton corps.', emoji: '💪', answer: 'Le fitness' },
        { clue: 'Tu participes à une compétition.', emoji: '🏆', answer: 'Un match' },
        { clue: 'Tu regardes un sport à la télévision.', emoji: '📺', answer: 'Un match / une compétition' },
        { clue: "Tu t'entraînes tous les jours.", emoji: '🔄', answer: "S'entraîner" },
      ],
      speaking: [
        'Quel sport tu pratiques ?',
        'Pourquoi le sport est important ?',
      ],
    },
    {
      id: 'fetes-a2',
      title: 'Les fêtes',
      questions: [
        { clue: 'Tu célèbres ton anniversaire avec…', emoji: '🎂', answer: 'Un gâteau' },
        { clue: 'Tu souffles les bougies sur…', emoji: '🕯️', answer: 'Le gâteau' },
        { clue: 'Tu donnes un objet à quelqu\u0027un.', emoji: '🎁', answer: 'Un cadeau' },
        { clue: 'Tu invites des amis chez toi.', emoji: '🎉', answer: 'Une fête' },
        { clue: 'Tu manges avec ta famille.', emoji: '🍽️', answer: 'Un repas' },
        { clue: 'Tu écoutes de la musique et tu danses.', emoji: '🎶', answer: 'La musique / danser' },
        { clue: 'Tu décores la maison avec…', emoji: '🎊', answer: 'Des décorations' },
        { clue: 'Tu prends des photos pendant la fête.', emoji: '📸', answer: 'Le téléphone / appareil photo' },
        { clue: 'Tu dis "joyeux anniversaire".', emoji: '🗣️', answer: 'Souhaiter' },
        { clue: 'Tu passes un bon moment avec les autres.', emoji: '😄', answer: "S'amuser" },
      ],
      speaking: [
        'Quelle fête tu préfères ?',
        'Comment tu célèbres ton anniversaire ?',
      ],
    },
  ],
};
